<template>
  <router-view :reg.sync="reg" @initReg="initReg"/>
</template>

<script>
const INIT_REG = {
  mail: '',
  password: '',
  companyName: '',
  userName: '',
  industry: '',
  receiveNotification: true,
  editState: 'editing',
}

export default {
  name: 'NewRegistration',
  data(){
    return {
      reg: { ...INIT_REG }
    }
  },
  methods: {
    initReg(){
      this.reg = { ...INIT_REG }
    }
  }
}
</script>

<style scoped>
</style>